import { mergeStyles } from "@uifabric/styling";
import { memoizeFunction } from "@uifabric/utilities";
var getClassNames = memoizeFunction(function (styles, className) {
    return {
        root: mergeStyles("vsplit", styles.root, className),
        splitter: mergeStyles("vsplit-splitter", styles.splitter),
        splitterContent: mergeStyles("vsplit-splitter-content", styles.splitterContent),
        topPane: mergeStyles("vsplit-top-pane", styles.topPane),
        topContent: mergeStyles("vsplit-top-content", styles.topContent),
        bottomPane: mergeStyles("vsplit-bottom-pane", styles.bottomPane),
        bottomContent: mergeStyles("vsplit-bottom-content", styles.bottomContent)
    };
});
export { getClassNames };
